import { CashBack, CurrencyFormat } from '@lt/components';
import InstantIcon from '@lt/components/icons-react/rebrand/Instant';
import React from 'react';
import styled from 'styled-components';
import { TEST_ID_MOBILE_SUMMARY_PRICE_TOTAL } from './constants';

type Props = {
  totalPrice: number;
  instantConfirm: boolean;
  cashbackAmount: number;
  packageId: number;
  cashbackLabel?: string;
  cashbackIconWebp?: string;
  cashbackIconPng?: string;
  cashbackTooltipText?: string;
  labelColor: string;
  textColor: string;
  activateCashbackForPartner: boolean;
};

const TotalPrice = (props: Props) => {
  const {
    totalPrice,
    instantConfirm,
    cashbackAmount,
    packageId,
    cashbackLabel,
    cashbackIconWebp,
    cashbackIconPng,
    cashbackTooltipText,
    labelColor,
    textColor,
    activateCashbackForPartner,
  } = props;
  return (
    <Wrapper>
      <Row>
        <Price data-testid={TEST_ID_MOBILE_SUMMARY_PRICE_TOTAL}>
          {instantConfirm && <StyledInstantIcon />}
          <CurrencyFormat value={totalPrice} />
        </Price>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <PackageId>№ {packageId}</PackageId>
      </Row>
      {activateCashbackForPartner && cashbackAmount ? (
        <CashBack
          count={`+${cashbackAmount}`}
          isMobile
          cashbackTooltipText={cashbackTooltipText}
          labelColor={labelColor}
          textColor={textColor}
          cashbackIconWebp={cashbackIconWebp}
          cashbackIconPng={cashbackIconPng}
          label={cashbackLabel}
        />
      ) : null}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 12px;
`;

const StyledInstantIcon = styled(InstantIcon)`
  height: 24px;
  margin-right: 4px;
`;

const Price = styled.div`
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
`;

const PackageId = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export default TotalPrice;
